import * as React from "react";
import { cn } from "../_internal/cn";
import type { TypeNarrativeDividerProps } from "./NarrativeDividerTypes";

/**
 * NarrativeDivider — a full-width, 1px horizontal rule that separates sections
 * within a narrative brief (e.g. a row of metrics from the headline/summary
 * block below it).
 *
 * Renders a semantic <hr> stripped of its user-agent margins and borders, then
 * draws a single 1px line with the container-border-base token (#dee1e1, which
 * also tracks dark mode). Styled via narrative-divider.css (Seeds CSS custom
 * properties); consumers import the classes through
 * @sproutsocial/racine/css/components. Overrides come via standard className /
 * style.
 */
const NarrativeDivider = React.forwardRef<
  HTMLHRElement,
  TypeNarrativeDividerProps
>(({ className, ...props }, ref) => (
  <hr
    ref={ref}
    className={cn("seeds-narrative-divider", className)}
    {...props}
  />
));

NarrativeDivider.displayName = "NarrativeDivider";

export default NarrativeDivider;
